import { Flex, useColorMode } from '@chakra-ui/react';
import React from 'react';

import { COLOR_SCHEMES } from 'packages/common-frontend/theme';
import {
  BACKGROUND_COLORS,
  BORDER_RADII,
} from 'packages/common-frontend/theme/tokens';
import { resolveColor } from 'packages/common-frontend/theme/utils';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Counter } from '~/packages/common-frontend/components/Counter';

// Constants
const COMPONENT_NAME = './common-frontend/Counter';

// Fragments
const RouteBase = () => {
  const { colorMode } = useColorMode();
  return (
    <PageTemplate title={COMPONENT_NAME}>
      <ComponentGridRenderer
        primaries={COLOR_SCHEMES}
        primaryPropName="colorScheme"
        secondaries={[null]}
        tertiaries={[null]}
        width="25rem"
      >
        {({ primary: colorScheme }) => {
          return (
            <Flex direction="column" gap="0.5rem" flexGrow={1}>
              <Flex
                justifyContent="space-between"
                gap="0.5rem"
                flexGrow={1}
                borderRadius={BORDER_RADII.md}
                padding="1rem"
              >
                <span>increaseContrast=false</span>
                <Counter colorScheme={colorScheme} count={99} />
              </Flex>
              <Flex
                justifyContent="space-between"
                gap="0.5rem"
                flexGrow={1}
                backgroundColor={resolveColor(
                  { colorMode, colorScheme },
                  BACKGROUND_COLORS.muted.base,
                )}
                borderRadius={BORDER_RADII.md}
                padding="1rem"
              >
                <span>increaseContrast=true</span>
                <Counter
                  colorScheme={colorScheme}
                  count={99}
                  increaseContrast
                />
              </Flex>
            </Flex>
          );
        }}
      </ComponentGridRenderer>
    </PageTemplate>
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
